// src/services/collectionsService.js
import { apiRequest } from './api';

/**
 * Fetch user's collection progress
 * @returns {Promise<Array>}
 */
export async function getCollectionProgress() {
    const response = await apiRequest('/collections/progress');
    return response.collections;
}